import { DataTable, DataTableCell, DataTableHead, DataTableRow } from '@/components/table/DataTable';
import { TablePager } from '@/components/table/TablePager';
import { aiApi, changeLines, changeWho, procedureLabel } from '@/lib/aiAdmin';
import { formatDateTime } from '@/lib/format';

import { TITLE, columns, LoadFailed, Loading, useCursorList } from './common';

/** The audit rows of every admin write: who, what, when, and the fields that changed. */
export function ChangesTab() {
  const list = useCursorList(async (token) => {
    const page = await aiApi.changes(token);
    return { rows: page.changes ?? [], next: page.nextPageToken };
  }, []);

  if (list.error) return <LoadFailed message={list.error} onRetry={list.reload} />;
  return (
    <DataTable footer={<TablePager {...list.pager} />}>
      <DataTableHead columns={columns(['When, who', 'What, target', 'Change'])} />
      <tbody>
        {list.rows.map((change) => (
          <DataTableRow key={String(change.id)}>
            <DataTableCell className={TITLE}>
              {formatDateTime(change.createdAt)}
              <span className="mt-0.5 block text-xs font-normal text-muted-foreground">{changeWho(change)}</span>
            </DataTableCell>
            <DataTableCell className="text-center">
              <span className="whitespace-nowrap">{procedureLabel(change.procedure)}</span>
              <span className="mt-0.5 block break-all text-xs text-muted-foreground">{change.target || '—'}</span>
            </DataTableCell>
            <DataTableCell className="text-center">
              {changeLines(change).map((line) => (
                <div key={line} className="break-words">
                  {line}
                </div>
              ))}
            </DataTableCell>
          </DataTableRow>
        ))}
        {list.loading && list.rows.length === 0 ? (
          <tr>
            <td colSpan={3}>
              <Loading label="Loading changes" />
            </td>
          </tr>
        ) : null}
        {!list.loading && list.rows.length === 0 ? (
          <tr>
            <td colSpan={3} className="px-4 py-8 text-center text-sm text-muted-foreground">
              No admin changes yet.
            </td>
          </tr>
        ) : null}
      </tbody>
    </DataTable>
  );
}
